import { makeAlenAxios } from ".";
import { AlenAccessToken } from "../authService";

export type DeviceDetail = {
  productId: string;
  deviceIds: string[];
};

export type DeviceActionPayload = {
  actionName: string;
  actionValue: string;
  actionType: "Bulk" | "Individual";
  deviceDetails: DeviceDetail[];
};

export const performDeviceActions = async (
  alenAccess: AlenAccessToken,
  payload: DeviceActionPayload
) => {
  const alenAxios = makeAlenAxios(alenAccess);
  const response = await alenAxios.post("/action", payload);
  return response;
};
